var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LogInSvg from './log-in-01.icon.svg';
export const LogInIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LogInSvg }));
_react_refresh_temp_1 = LogInIcon;
$RefreshReg$(_react_refresh_temp_1, "LogInIcon");
